import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import { connect } from 'react-redux';
import { pageTitle, isHome } from './../../actions';
import { checkInternet } from './../../utils/checkInternet';
import { hasInternet } from './../../actions';

class About extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.props.dispatch(isHome(false));
        this.props.dispatch(hasInternet(checkInternet()));
        this.props.dispatch(pageTitle("درباره ما"));
        if (this.props.socket) {
            this.getData(this.props.socket);
        }
    }

    componentDidUpdate(prevProps) {
        this.props.dispatch(hasInternet(checkInternet()));
        if (this.props.socket && this.props.socket !== prevProps.socket) {
            this.getData(this.props.socket);
        }
    }

    getData = socket => {
        socket.on('about', data => {
            this.setState({ about: data });
        });
        socket.emit("about");
    };

    renderLink = (href, text) => {
        if (!href) return null;
        return (
            <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
            >
                {text || href}
            </a>
        );
    };

    render() {
        const { about } = this.state;

        if (!about) {
            return (
                <div className="loading">
                    <span></span>
                </div>
            );
        }

        return (
            <div className="about-area">
                <Card className="about-item">
                    <div className="about-txt">
                        <pre>{about.about}</pre>
                    </div>

                    <ul className="contact">  {/* اصلاح: class به className */}
                        <li>
                            <span>
                                <i className="fas fa-map-marker-alt"></i>
                                آدرس :
                            </span>
                            {about.address || 'تعریف نشده'}
                        </li>

                        <li>
                            <span>
                                <i className="fas fa-envelope"></i>
                                پست الکترونیک :
                            </span>
                            {about.email && (
                                <a href={`mailto:${about.email}`}>
                                    {about.email}
                                </a>
                            )}
                        </li>

                        <li>
                            <span>
                                <i className="fas fa-phone"></i>
                                شماره تماس :
                            </span>
                            {Array.isArray(about.phone) && about.phone.length > 0 ? (
                                <ul>
                                    {about.phone.map((phone, index) => (
                                        <li key={index}>
                                            <a className="call-link" href={`tel:${phone}`}>
                                                {phone}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            ) : <span>تعریف نشده</span>}
                        </li>

                        <li>
                            <span>
                                <i className="fas fa-mobile-alt"></i>
                                شماره همراه :
                            </span>
                            {Array.isArray(about.mobile) && about.mobile.length > 0 ? (
                                <ul>
                                    {about.mobile.map((phone, index) => (
                                        <li key={index}>
                                            <a className="call-link" href={`tel:${phone}`}>
                                                {phone}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            ) : <span>تعریف نشده</span>}
                        </li>

                        <li>
                            <span>
                                <i className="fa fa-globe"></i>  {/* اصلاح: fal به fa */}
                                وب‌سایت :
                            </span>
                            {about.website && this.renderLink(about.website, about.website)}
                        </li>
                    </ul>

                    <ul className="social-network">
                        {about.facebook && (
                            <li>
                                {this.renderLink(about.facebook, <i className="fab fa-facebook-f"></i>)}
                            </li>
                        )}
                        {about.twitter && (
                            <li>
                                {this.renderLink(about.twitter, <i className="fab fa-twitter"></i>)}
                            </li>
                        )}
                        {about.instagram && (
                            <li>
                                {this.renderLink(about.instagram, <i className="fab fa-instagram"></i>)}
                            </li>
                        )}
                        {about.telegram && (
                            <li>
                                {this.renderLink(about.telegram, <i className="fab fa-telegram-plane"></i>)}
                            </li>
                        )}
                        {about.linkedin && (
                            <li>
                                {this.renderLink(about.linkedin, <i className="fab fa-linkedin-in"></i>)}
                            </li>
                        )}
                    </ul>

                    <div className="copyright">
                        {about.copyright || ''}
                    </div>
                </Card>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    socket: state.setSocket
});
export default connect(mapStateToProps)(About);
